var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", [
      _vm.statusOne
        ? _c("div", [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("notification.customerOwnershipRemoved", {
                    actor: _vm.$_.get(_vm.activity, "actorUser.name"),
                    visitor: _vm.maskedVisitorName,
                    oldOwner: _vm.$_.get(_vm.activity, "payload.oldOwnerName"),
                  })
                ),
              },
            }),
          ])
        : _vm.statusTwo
        ? _c("div", [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("notification.customerOwnershipAssigned", {
                    actor: _vm.$_.get(_vm.activity, "actorUser.name"),
                    visitor: _vm.maskedVisitorName,
                    newOwner: _vm.$_.get(_vm.activity, "payload.ownerName"),
                  })
                ),
              },
            }),
          ])
        : _vm.statusThree
        ? _c("div", [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("notification.customerOwnershipReassigned", {
                    actor: _vm.$_.get(_vm.activity, "actorUser.name"),
                    visitor: _vm.maskedVisitorName,
                    oldOwner: _vm.$_.get(_vm.activity, "payload.oldOwnerName"),
                    newOwner: _vm.$_.get(_vm.activity, "payload.ownerName"),
                  })
                ),
              },
            }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }